import React, { useEffect } from "react";
/**
 * Component which would listen to DraggableEvent, update the component position or react accordingly.
 *
 * @param props IDraggableEventReceiverProps
 * @returns
 */
const DraggableEventReceiver = props => {
  useEffect(() => {
    const listener = event => {
      const {
        data
      } = event;
      if (data.channel && props.channel && data.channel === props.channel) {
        props.onEvent(data);
      }
    };
    window.addEventListener("message", listener);
    return () => {
      window.removeEventListener("message", listener);
    };
  }, [props]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, " ", props.children, " ");
};
export default DraggableEventReceiver;